<template>
  <nav class="header-nav">

    <!-- لوگو -->
    <router-link
        to="/"
        class="logo-wrapper"
    >
      <div class="logo">
        <picture>
          <source
              media="(max-width: 768px)"
              srcset="@/assets/images/logo-mobile.png"
          >

          <img
              src="@/assets/images/logo-s.png"
              alt="لوگوی سایت"
          >
        </picture>
      </div>
    </router-link>

    <!-- منوی اصلی -->
    <div class="nav">

      <router-link to="/">
        خانه
      </router-link>

      <router-link to="/news">
        اخبار
      </router-link>

      <router-link to="/competition/14">
        لیگ‌ها
      </router-link>

      <router-link to="/matches">
        مسابقات
      </router-link>

      <router-link to="/compare">
        مقایسه
      </router-link>

      <router-link to="/fifa-day">
        فیفا دی
      </router-link>

      <router-link to="/special">
        ویژه
      </router-link>

      <router-link to="/did-you-know">
        دانستنی‌ها
      </router-link>

    </div>

    <!-- جستجو و ورود -->
    <div class="header-search">

      <input
          type="text"
          placeholder="جستجو ..."
      >

<!--      <router-link-->
<!--          class="login-link"-->
<!--          to="/login"-->
<!--      >-->
<!--        ورود-->
<!--      </router-link>-->

    </div>

  </nav>
</template>

<script>

export default {

  name: 'HeaderNav'

}

</script>

<style scoped lang="scss">

.header-nav {

  display: flex;

  align-items: center;

  width: 100%;

  height: 80px;

  gap: 40px;

}


/* =========================
   LOGO
========================= */

.logo-wrapper {

  flex: 0 0 150px;

  display: flex;

  align-items: center;

  justify-content: center;

  text-decoration: none;

}

.logo {
  //flex-basis: 15%;
  max-width: 180px;

  picture {
    display: block;
  }

  img {
    display: block;
    width: 100%;
    max-width: 180px;
    height: auto;
    object-fit: contain;
  }
}


/* =========================
   NAV
========================= */

.nav {

  display: flex;

  align-items: center;

  gap: 32px;

  flex: 1;

  min-width: 0;

}

.nav a {

  color: #fff;

  text-decoration: none;

  white-space: nowrap;

}

.nav .router-link-exact-active {

  color: #42d392;

}


/* =========================
   SEARCH
========================= */

.header-search {

  flex: 0 0 250px;

  display: flex;

  align-items: center;

  gap: 20px;

}

.header-search input {

  width: 180px;

  height: 34px;

  border: none;

  border-radius: 999px;

  padding: 0 16px;

  outline: none;

}

.login-link {

  color: #fff;

  text-decoration: none;

  white-space: nowrap;

}


/* =========================
   LAPTOP (1025–1280) — هدر فشرده‌تر
   هدر کامل ≈۱۲۳۰px جا می‌شود؛ زیر ۱۲۸۰ باید جمع‌وجور شود وگرنه
   لینک‌ها/جستجو سرریز می‌کنند
========================= */

@media (min-width: 769px) and (max-width: 1280px) {

  .header-nav {
    gap: 18px;
  }

  .logo-wrapper {
    flex: 0 0 110px;
  }

  .logo img {
    max-width: 140px;
  }

  .nav {
    gap: 18px;
  }

  .nav a {
    font-size: 13.5px;
  }

  .header-search {
    flex: 0 0 auto;
  }

  .header-search input {
    width: 130px;
  }

}

/* =========================
   TABLET (769–1024) — جستجو حذف، منو فشرده + اسکرول ایمن
========================= */

@media (min-width: 769px) and (max-width: 1024px) {

  .nav {
    gap: 12px;
    /* تور ایمنی: اگر باز هم جا نشد، منو خودش اسکرول افقی بگیرد نه اینکه سرریز کند */
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .nav::-webkit-scrollbar {
    display: none;
  }

  .nav a {
    font-size: 13px;
    padding: 6px 2px;
  }

  .header-search input {
    display: none;
  }

}

/* =========================
   MOBILE
========================= */

@media (max-width: 768px) {

  .header-nav {
    height: 60px;
    gap: 8px;
    justify-content: center;
  }

  .logo-wrapper {
    flex: 0 0 52px;
    width: 52px;
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {

    .logo {
      flex-basis: auto;
      max-width: none;
      width: auto;

      img {
        width: auto;
        height: 52px;
        max-width: 140px;
      }
    }

  }

  .nav {
    flex: 1;
    justify-content: space-between;
    gap: 0;
    /* ۸ لینک جا نمی‌شود — اسکرول افقی نرم به‌جای بریده‌شدن */
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .nav::-webkit-scrollbar {
    display: none;
  }

  .nav a {
    font-size: 12px;
    padding: 8px 4px;
    white-space: nowrap;
  }

  .header-search {
    flex: 0 0 auto;
  }

  .header-search input {
    display: none;
  }

  .login-link {
    font-size: 12px;
    padding: 6px 4px;
  }

}

</style>